import FreeTextPoll from './free_text_poll'
import DiscourseResults from './discourse_results'
import DiscourseVotes from './discourse_votes'

const QA_FETCH_INTERVAL = 3000

export default class Discourse extends FreeTextPoll {
  get defaultType () {
    return 'discourse'
  }

  /**
   * Collection of participant submitted question results. This overrides the
   * base property to make it return a discourse results collection instead.
   * @return {Results}
   */
  get results () {
    if (!this._results) {
      this._results = new DiscourseResults(this.get('results'), { poll: this })
    }
    return this._results
  }

  get myVotes () {
    if (!this._myVotes) {
      this._myVotes = new DiscourseVotes(this.get('my_votes'), { poll: this })
    }
    return this._myVotes
  }

  showPath () {
    const permalink = this.get('permalink')

    return `/discourses/${permalink}`
  }

  fetch (options) {
    this.fetchOptions = options
    return super.fetch(...arguments)
  }

  sendToListUrl () {
    return undefined
  }

  /**
   * Live update the discourse data
   * Not using instance.start as this doesn't use firehose
   */
  liveUpdate () {
    // Fetch every 3 seconds
    this.fetchInterval = setInterval(this.fetch.bind(this), QA_FETCH_INTERVAL)
  }

  stopLiveUpdate () {
    clearInterval(this.fetchInterval)
  }
}
